export const ORANGE = "#FF9015";
export const TRANSITION_SMOOTH = "all 0.28s cubic-bezier(0.4, 0, 0.2, 1)";

export const iconButtonSx = {
  minWidth: 44,
  minHeight: 44,
  borderRadius: "12px",
  transition: TRANSITION_SMOOTH,
  "&:hover": {
    backgroundColor: "rgba(0,0,0,0.06)",
    transform: "scale(1.06)",
  },
  "&:active": {
    transform: "scale(0.96)",
  },
};
